import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface FacebookCircleIconProps extends SvgIconProps {}

export const FacebookCircleIcon = ({
  style,
  ...iconProps
}: FacebookCircleIconProps): ReactElement => {
  style = {
    fontSize: '1em',
    ...style,
  };
  return (
    <SvgIcon
      style={style}
      {...iconProps}
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <defs>
        <clipPath>
          <rect width="30" height="30" fill="none" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-path)">
        <path
          d="M29.737,14.868A14.868,14.868,0,1,0,12.545,29.556V19.166H8.77v-4.3h3.775V11.593c0-3.726,2.22-5.785,5.616-5.785a22.864,22.864,0,0,1,3.328.29V9.757H19.615a2.149,2.149,0,0,0-2.423,2.322v2.789h4.124l-.659,4.3H17.192v10.39A14.872,14.872,0,0,0,29.737,14.868"
          transform="translate(0.132 0.132)"
          fill="#1877f2"
        />
        <path
          d="M313.886,213.358l.659-4.3h-4.124v-2.789a2.149,2.149,0,0,1,2.423-2.322h1.875V200.29a22.863,22.863,0,0,0-3.328-.29c-3.4,0-5.616,2.058-5.616,5.785v3.276H302v4.3h3.775v10.39a15.024,15.024,0,0,0,4.646,0v-10.39Z"
          transform="translate(-293.098 -194.06)"
          fill="#fff"
        />
      </g>
    </SvgIcon>
  );
};
